export default __webpack_public_path__ + "microphone-off.png";